module.exports = __webpack_public_path__ + "img/Sunglasses.a0d646d5.png";